import axios from 'axios';
import BackendClient from '../backend-client';
import Notification, { modelFactory } from './model';

export default class BookmarksClient extends BackendClient {
  constructor(options = {}) {
    super(modelFactory, options);
  }

  get = async (type) => {
    const response = await this.request('get', `list/${type}`)();
    return this.format(response);
  }

  set = (type, data) => {
    const cancelToken = axios.CancelToken.source();

    const req = this.request('post', `list/${type}`)(data, {
      cancelToken: cancelToken.token,
    });

    req.cancel = () => {
      req.cancelled = true;
      cancelToken.cancel('Operation was cancelled by user interaction');
    };

    req.format = this.format.bind(this);

    return req;
  }
}

export {
  Notification,
};
